import Space from './Space.vue';

export default Space;
